/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ accruing: NonNullable<unknown>, month: NonNullable<unknown> }} Partner_Billing_Board_Alltime_Accruing_OnlyInputs */



/**
* | output |
* | --- |
* | "Nothing is billable yet — {accruing} accruing in {month}, becomes billable when it closes." |
*
* @param {Partner_Billing_Board_Alltime_Accruing_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_accruing_only = /** @type {((inputs: Partner_Billing_Board_Alltime_Accruing_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_Accruing_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Noch nichts fakturierbar — ${i?.accruing} läuft in ${i?.month} auf und wird fakturierbar, sobald der Monat endet.`)
	return /** @type {LocalizedString} */ (`Nothing is billable yet — ${i?.accruing} accruing in ${i?.month}, becomes billable when it closes.`)
});